<script setup lang="ts">
import { computed } from 'vue'

import type { ContentBuilderContainerProps } from '@fondof-ui/components/content-builder/types.ts'

const props = defineProps<ContentBuilderContainerProps>()

const delegatedProps = computed(() => {
  const { class: _, removeSpace: __, ...delegated } = props

  return delegated
})
</script>

<template>
  <div
    :class="[
      props.class,
      {
        'md:px-15 lg:px-25 xl:px-30 px-5 sm:px-10 2xl:px-40':
          !props.removeSpace?.includes('left and right'),
        'pt-15 md:pt-17.5 lg:pt-20': !props.removeSpace?.includes('top'),
        'pb-15 md:pb-17.5 lg:pb-20': !props.removeSpace?.includes('bottom'),
      },
    ]"
    v-bind="delegatedProps"
  >
    <slot />
  </div>
</template>
